module.exports = __webpack_public_path__ + "static/media/85450006-RoG0wSgs.ddbaf40a.JPG";